import { __rest } from "tslib";
import { useContext } from "react";
import { EditUpdateBehavior } from "@plansoft-configuration-renderer/framework";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
/**
 * Get control props from layout
 * @returns
 */
export function useEditControlLayoutProps() {
    const _a = useContext(ControlLayoutContext), { multiline = false, debounceDelay = 500, showReset = false, showValueRange = true, updateBehavior = EditUpdateBehavior.OnChange } = _a, rest = __rest(_a, ["multiline", "debounceDelay", "showReset", "showValueRange", "updateBehavior"]);
    return Object.assign({ multiline,
        debounceDelay,
        updateBehavior,
        showReset,
        showValueRange }, rest);
}
// compat exports
export { useEditControlLayoutProps as useTextEditControlLayoutProps };
export { useEditControlLayoutProps as useNumericEditControlLayoutProps };
//# sourceMappingURL=useEditControlLayoutProps.js.map